const Subscription = {
    // HEADER
    "subscription": "Subscription",
    "order_list": "Order List",
    "payment_list": "Payment List",
    "order": "Order",

    // TABLE HEADERS
    "table_no": "S.No",
    "table_payment_id": "PAYMENT ID",
    "table_razorpay_order_id": "RAZORPAY ORDER ID",
    "table_order_id": "ORDER ID",
    "table_user_name": "USER",
    "table_amount": "AMOUNT",
    "table_plan_name": "PLAN",
    "table_payment_status": "PAYMENT STATUS",
    "table_status": "STATUS",
    "table_date": "DATE",

    // FILTERS
    "search": "Search",
}

export default Subscription;
